<template>
    <div class="mainLayout">
        <div class="lookup lookupDiv inner">

            <p class="innerTitle">{{lookupPromptText}}</p>
            <select name="" id="" class='lookupSelect' v-model="filterByRole" >
                <option v-for="role in roles" :key="role.id" :value="role.id">
                    {{role.name}}
                </option>
            </select>
            <select name="" id="" class='lookupSelect' v-model="filterByClub">
                <option v-for="club in clubs" :key="club.id" :value="club.id">
                    {{club.name}}
                </option>
            </select>
            <div class="horizFlex">
                <input ref="lookupText" id="lookupText"  class='lookupText' v-model="badgeValue"  @keyup.enter='lookup'/>
                <button class="lookupGo" v-on:click="lookup">{{lookupButtonText}}</button>
            </div>
             <div class="inactiveCheck">
                <input type="checkbox" id="jake" v-model="showInactivePeople" @change="lookup">
                <label for="jake" class="rosterName" >{{showInactiveText}}</label>
            </div>
            <div class="wait" v-show="pleaseWait">
                <label for="">Please Wait...</label>
            </div>
            <div class="error">
                <label for="">{{errorMessage}}</label>
            </div>
            <div class="lookupInstructions" >
                <label for="">{{lookupInstructionsText}}</label>
            </div>
            <div class="lookupResults scrollDivResults" >
                <button class="resultButton" v-for="result in lookupResults" :key="result.id" v-on:click="getPerson(result.id)">
                    {{result.name}}
                </button>
            </div> 
        </div>
        
        <div v-if="isSelectedResult">
            <div class="main inner personCard" >
                <div class="personPhoto" v-if="selectedResult.imageName!=null">
                    <img :src="getImage(selectedResult.imageName)"  width="100" class="image" >
                </div>
                <div class="personAddress">
                    <div class="horizFlex">
                        <p class="personName">{{selectedResult.firstName}} {{selectedResult.lastName}}</p> 
                        <!-- <p v-bind:class="assocDuesClass">{{assocDuesText}}</p> -->
                    </div>
                
                    <div class="horizFlex">
                        <ul class="textlist" >
                            <li v-if="selectedResult.address1!=null">{{selectedResult.address1}}</li>
                            <li v-if="selectedResult.city!=null">{{selectedResult.city + ', ' + selectedResult.state + ' ' + selectedResult.zip}}</li>
                            <hr/>
                            <li>{{selectedResult.phone | formatPhone}}</li>
                            <button class="linkButton linkButtonMedium" >{{ selectedResult.email }}</button>
                            <li>#{{selectedResult.code }}</li>
                        </ul>
                        <ul class="textlist" >
                            <!-- <li>{{'Gender: ' + selectedResult.gender }}</li> -->
                            <!-- <button class="linkButton linkButtonMedium" v-on:click="getPerson(selectedResult.spouseId)">{{'Spouse: ' + selectedResult.spouseName }}</button> -->
                        </ul>
                    </div>
                    
                </div>
                
                <!-- <div class="personAction" v-if="!inEdit">
                    <button class="buttonPerson" v-on:click="editPerson()" disabled=true>{{editButtonText}}</button>
                </div>
                <div class="personAction" v-if="inEdit">
                    <button class="buttonPerson" v-on:click="savePerson()">{{saveButtonText}}</button>
                    <button class="buttonPerson" v-on:click="cancelEditPerson()">{{cancelButtonText}}</button>
                </div> -->
            </div>
            <div class="detail innerTransparent">
                
                <div class="itemTitleBar">
                    <div class="horizFlex itemTitle">
                        <p class="itemBarTitle itemTitle">{{clubTitleText}}</p>
                        <!-- <p class="itemBarSubTitle">{{firstAttendedText}} {{selectedResult.firstAttendedDate}}</p>
                        <p class="itemBarSubTitle">{{lastAttendedText}} {{selectedResult.lastAttendedDate}}</p> -->
                        <p class="itemBarSubTitle">{{clubCountText}} {{selectedResult.clubCount}}</p>
                    </div>
                    <div class="inactiveCheck">
                        <input type="checkbox" id="jake" v-model="showInactiveClubs">
                        <label for="jake" class="rosterName" >{{showInactiveText}}</label>
                    </div>
                    <button class="addButton" v-on:click="addNewClub()" :disabled="disableEdit">{{addClubButtonText}}</button>
                    
                </div>
                <div class="scrollDiv" ref="clubdiv">
                    <div v-bind:class="clubClass(club.clubMembershipId)" v-for="club in filteredClubs" :key="club.clubMembershipId" v-on:click="toggleClub(club.clubMembershipId)">
                        <!-- club and role -->
                        <div v-if="!clubInEdit(club.clubMembershipId)">
                            
                            <p class="innerTitle clubTitle">{{clubNameText(club)}}</p>
                            
                            <!-- <ul class="textlist margin20" v-if="clubShowDetail(club.clubMembershipId)">
                                <li>{{enrolledDateText}} {{club.enrolledDate}}</li>
                                <li>{{startedRoleText}} {{club.roleDate}}</li>
                                <li>{{lastAttendedText}} {{club.lastAttendedDate}}</li>
                            </ul>  -->
                            
                        </div>
                        <div v-if="clubInEdit(club.clubMembershipId)">
                            <p class="innerTitle clubTitle">{{clubNameText(club)}}</p>
                            <!-- only show club picker if it is a new one, membershipid=-1 -->
                            <div class="horizFlex" v-if="club.clubMembershipId==-1">
                                <label for="" class="editLabel">Club</label>
                                <select name="" id="" class='lookupSelect' v-model="club.clubId" >
                                    <option v-for="selClub in clubsWithoutAll" :key="selClub.id" :value="selClub.id" >
                                        {{selClub.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="horizFlex">
                                <label for="" class="editLabel">Role</label>
                                <select name="" id="" class='lookupSelect' v-model="club.roleId" >
                                    <option v-for="role in rolesWithoutAll" :key="role.id" :value="role.id">
                                        {{role.name}}
                                    </option>
                                </select>
                            </div>
                            
                        </div>

                        <!-- dues -->
                        <div v-if="!clubInEdit(club.clubMembershipId)" class="horizFlex">
                            <!-- <p v-bind:class="clubDuesClass(club.clubMembershipId)">{{clubDuesText(club.clubMembershipId)}}</p>   -->
                            <p class="unpaid" v-if="!club.isActive">INACTIVE</p>  
                        </div>
                        <div v-if="clubInEdit(club.clubMembershipId)">
                            <!-- <div v-bind:class="clubDuesClass(club.clubMembershipId)">
                                <input type="checkbox" id="jake" v-model="club.duesPaid">
                                <label for="jake" class="rosterName" >{{editDuesPaidText}}</label>
                            </div> -->
                            <div class="isactive">
                                <input type="checkbox"  v-model="club.isActive" v-on:click="updateIsActive(!club.isActive)">
                                <label  class="rosterName" >{{isActiveText}}</label>
                            </div>
                        </div>
                        
                         <!-- actions -->
                        <div class="itemAction" v-if="!clubInEdit(club.clubMembershipId)">
                            <button class="button" v-on:click="editClub(club.clubMembershipId)" :disabled="disableEdit">{{editButtonText}}</button>
                        </div>
                        <div class="itemAction" v-if="clubInEdit(club.clubMembershipId)">
                            <button class="button" v-on:click="saveClub(club.clubMembershipId)">{{saveButtonText}}</button>
                            <button class="button" v-on:click="cancelEditClub(club.clubMembershipId)">{{cancelButtonText}}</button>
                        </div>

                    </div>   
                   
                </div>
            </div>
        </div>
    </div>

  
</template>

<script>
import {HTTP} from '../Repository'
import tokenhelper from '../tokenhelper.js'
export default {
    mixins:[tokenhelper],
    props:{
        canEdit:{
            type:String,
            default:'false'
        },
    },
    data(){
        return{
            imageBasePath:'',
            pleaseWait:false,
            errorMessage:'',

            roles:{},
            clubs:{},
            
            badgeValue:'',
            filterByClub:-1,
            filterByRole:-1,
            lookupResults:{},
            
            selectedResult:{},
            isSelectedResult:false,
            inEdit:false,
            showInactiveClubs:true,
            showInactivePeople:false,
            clubStates:{},

            lookupInstructionsText:'Filter by at least club or text',
            lookupPromptText:'Lookup Person',
            lookupButtonText:'Go',
            editButtonText:'Edit',
            firstAttendedText:'First Attended',
            lastAttendedText:'Last Attended:',
            startedRoleText:'Started Role:',
            enrolledDateText:'Enrolled:',
            addClubButtonText:'Add Club',
            showInactiveText:'Show Inactive',
            clubCountText:'# Clubs:',
            clubTitleText:'Clubs',
            saveButtonText:'Save',
            cancelButtonText:'Cancel',
            editDuesPaidText:'Dues Paid',
            isActiveText:'Is Active'
        }
    },
    mounted(){
        this.getImageBasePath();
        this.getClubs();
        this.getRoles();
    },
    computed:{
        disableEdit:function(){
            return this.canEdit=='false' || this.canEdit=='False'
        },
    	assocDuesText:function(){
            if(this.selectedResult.associationDuesPaid){
                return "$ Association Dues: Paid";
            }else{
                return "$ Association Dues: UNPAID";
            }
        },
        assocDuesClass:function(){
            if(this.selectedResult.associationDuesPaid){
                return "paidmain";
            }else{
                return "unpaidmain";
            }
        },
        filteredClubs(){
            if(this.showInactiveClubs){
                return this.selectedResult.clubs
            }else{
                
                let tempClubs = this.selectedResult.clubs
                if(tempClubs!=undefined){
                    tempClubs = tempClubs.filter((item)=>{
                        return (item.isActive)
                    })
                    return tempClubs
                }
                
                
                
            } 
        },
        clubsWithoutAll(){
            let tempClubs = this.clubs
            tempClubs.splice(0,1);
            return tempClubs;
        },
        rolesWithoutAll(){
            let tempRoles = this.roles;
            tempRoles.splice(0,1);
            return tempRoles;
        }
    },
    filters: {
        formatPhone(phn) {

            if(phn!=null){
                return "(" + phn.substring(0,3) + ") " + phn.substring(3,6) + "-" + phn.substring(6);       
            }
            
        }
    },
    methods:{
        AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        selectClub(clubName){
            console.log(clubName)
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                club.clubName=clubName
            }
        },
        updateIsActive(isActive){
            console.log("updateIsActive " + isActive)
            if(isActive==false){
                this.showInactiveClubs=true;
            }
        },
        addNewClub(){
            this.$refs.clubdiv.scrollTop=0
            let newclub={'clubMembershipId':-1,'clubId':'0', 'personId':this.selectedResult.id,'clubName':'Add New Club','roleId':'-1','duesPaid':false,'isActive':true};
            console.log(newclub)
            this.selectedResult.clubs.splice(0,0,newclub);
            this.editClub(-1);
        },
        getImageBasePath(){
            this.imageBasePath = window.VUE_CONFIG_API + 'personimage/'
            console.log("img path " + this.imageBasePath)
            
          
        },
        getRoles(){
            let req = {
                memberID:"1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('roles',req)
            .then(response=>{
                this.roles = response.data.roles
                
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
        },
        getClubs(){

            let req = {
                memberID:"1"
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('clubs',req)
            .then(response=>{
                this.clubs = response.data.ClubList
          
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });

        },
        lookup(){
            //require at least text or club
            if(this.filterByClub==-1 && (this.badgeValue==null || this.badgeValue=='')){
                return;
            }
            // initial scan
            let req = {
                lookupText:this.badgeValue,
                club:this.filterByClub,
                role:this.filterByRole,
                includeInactive:this.showInactivePeople
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('lookup',req)
            .then(response=>{
                this.lookupResults = response.data.PersonList
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
        },

        editPerson(){
            this.inEdit=true
        },
        
        cancelEditPerson(){
            this.inEdit=false
        },
           
        getClubByID(clubMembershipId){
            var i;
            for(i=0;i<this.selectedResult.clubs.length;i++){
                var club = this.selectedResult.clubs[i]
                if(club.clubMembershipId==clubMembershipId){return club}
            }
        },
        toggleClub(clubMembershipId){
            
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                if(club.tag==""){
                    club.tag="Detail"
                }else if(club.tag=="Detail"){
                    club.tag=""
                }
            }
            
        },
        clubShowDetail(clubMembershipId){
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                return club.tag=="Detail" || club.tag=="Edit"
            }
        },
        clubInEdit(clubMembershipId){
  
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                return club.tag=="Edit"
            }
        },
        editClub(clubMembershipId){
        
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                club.tag="Edit"
            }
        },
        saveClub(clubMembershipId){
         
            //API save
            //this.savePerson();
            var club = this.getClubByID(clubMembershipId)

         
            let req = {
                clubmembership:club
            }
            this.AddTokenToAPI();
            HTTP.post('savemembership',req)
            .then(response=>{
               
                if(club!=undefined){
                    club.tag=""
                    club.clubMembershipId=response.data.ResponseInteger
                    this.getPerson(this.selectedResult.id)
                }
                
            })
            .catch(e=>{
                console.log(e)
            });


            
        },
        cancelEditClub(clubMembershipId){
       
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                club.tag=""
                if(club.clubMembershipId==-1){
                    this.selectedResult.clubs.splice(0,1);
                }
                //put the data back
                this.getPerson(this.selectedResult.id)
            }
        },
        clubClass(clubMembershipId){
            var club = this.getClubByID(clubMembershipId)
            if(club!=undefined){
                if(!club.isActive){
                    return "inner innerInactive itemDetail"
                }else if(club.tag=="Detail"){
                    return "inner itemDetailOpen";
                }else{
                    return "inner itemDetail";
                }
            }
            
        },
        clubDuesClass(clubMembershipId){
            var club = this.getClubByID(clubMembershipId)
            if(club.duesPaid){
                return "paid";
            }else{
                return "unpaid";
            }
        },
        clubDuesText(clubMembershipId){
            var club = this.getClubByID(clubMembershipId)
            if(club.duesPaid){
                return "Dues $: Paid";
            }else{
                return "Dues $: UNPAID";
            }
        },
        clubNameText(club){
            //var club = this.getClubByID(clubMembershipId)
            //club.roleName = this.getRoleName(club.roleId)
            //if(club.clubId!=0){
            //    console.log(club)
             //   club.clubName=this.getClubName(club.clubId)
            //}
            if(club.roleName!=""){
                return club.clubName + " (" + club.roleName + ")";
            }else{
                return club.clubName;
            }
        },
        getRoleName(roleId){
            var i;
            for(i=0;i<this.roles.length;i++){
                var role = this.roles[i]
                if(role.id==roleId){return role.name}
            }
        },
        getClubName(clubId){
            var i;
            for(i=0;i<this.clubs.length;i++){
                var club = this.clubs[i]
                if(club!=undefined){
                    if(club.id==clubId){return club.name}
                }
                
            }
        },
        getPerson(personID){
            console.log("get " + personID)
            this.isSelectedResult=true;
            let req = {
                personId:personID
            }
            this.pleaseWait=true;
            this.AddTokenToAPI();
            HTTP.post('person',req)
            .then(response=>{
                this.selectedResult = response.data.Person
                if(this.selectedResult.state==null){this.selectedResult.state=''}
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                return e
            });
  
        },
        getImage(imagePath){
            imagePath=imagePath.replace('.jpg','')
            return this.imageBasePath + imagePath
        },
        savePerson(){
            console.log("save ")
            let req = {
                Person:this.selectedResult
            }
            this.AddTokenToAPI();
            HTTP.post('saveperson',req)
            .then(response=>{
                this.handleSaveResult()
                
            })
            .catch(e=>{
                console.log(e)
            });
        },
        handleSaveResult(){
            this.inEdit=false
        }

    }
}
</script>

<style scoped>
.wait{
    font-size:x-large;
    color:rgb(238,120,45);
    padding:20px;
}
.error{
    font-size:large;
    color:red;
    padding:20px;
}
/* main */
.mainLayout{
    height:95%;
    display:grid;
    grid-template-columns:1fr 4fr;
    grid-template-rows:1fr 3fr;
    grid-template-areas: 
    "lookup main"
    "lookup detail";
}
.margin20{
    margin:20px;
}
/*areas*/
.lookup{
    grid-area:lookup;
}
.main{
    grid-area:main; 
}
.detail{
    grid-area:detail; 
    
}
.scrollDiv{
    height:360px;
    overflow-x:hidden;
    overflow-y:scroll;
    
}
.scrollDivResults{
    height:390px;
    overflow-x:hidden;
    overflow-y:scroll;
}
.inner{
    border-radius:10px; 
    margin:10px;
    padding:0px;
    text-align: left;
    background-color: white;
}
.innerInactive{
    background-color: lightgray;
}
.innerTitle{
    font-size:x-large;
    color:rgb(0,158,192);
}
.horizFlex{
  display:flex;
  flex-direction: row;
  
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
}
.linkButtonMedium{
  font-size:medium;
  
}
/*lookup*/
.lookupDiv{
    grid-area:lookup;
    /* height:95%; */
    padding-left:10px;
    padding-right:10px;
}

.lookupText{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
}
.lookupInstructions{
    margin-top:5px;
    font-size:small;
}
.lookupGo{
    background-color: rgb(238,120,45);
    border:none;
    border-radius:5px;
    margin-left:3px;
    color:white;
}
.lookupSelect{
  outline-color:rgb(238,120,45);
  outline-width:2px;
  border-radius: 5px;
  font-size:inherit;
  width:200px;
  margin-bottom:5px;
}

.lookupResults{
    padding:0px;
    margin-top:10px;
}
.resultButton{
    width:96%;
    margin:5px;
    background-color:rgb(196, 218, 226);
    border:none;
    border-radius:10px;
    padding:10px;
    color:rgb(0,158,192);
    font-size:medium;
}
.resultButton:focus{
    /* color:rgb(238,120,45); */
    font-weight:bold;
    outline-style:none;
    border-color:rgb(238,120,45);
    border-width:2px;
    border-style:solid;
}
/* personcard */
.personCard{
    display:grid;
    grid-template-columns:130px 350px auto 10px;
    grid-template-rows:auto;
    grid-template-areas: 
    "photo address space personaction";
}
.personPhoto{
    grid-area:photo;
}
.image{
    margin:20px;
}
.personAddress{
    grid-area:address;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    margin-left:10px;
}
.personAction{
    grid-area:personaction;
    display:flex;
    flex-direction: column;
    text-align: center;
}

.personName{
    font-size:xx-large;
    font-weight:bold;
    color:rgb(0,158,192);
    margin-bottom:5px;
    margin-top:10px;
}
.textlistdiv{
    text-align:left;
}
.textlist{
    list-style-type:none;
    padding-left:0;
    margin-right:60px;
}
.paidmain{
    color:green;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.unpaidmain{
    color:red;
    font-size:large;
    margin-top:20px;
    margin-left:30px;
}
.paid{
    color:green;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.unpaid{
    color:red;
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
.isactive{
    font-size:large;
    margin-top:10px;
    margin-left:30px;
}
.inactive{
    color:rgb(53, 48, 48);
    font-size:large;
    margin-top:27px;
    margin-left:30px;
}
/* club item */
.itemDetailOpen{
    display:grid;
    grid-template-columns:300px auto 10px 120px;
    grid-template-rows:1fr 1fr;
    grid-template-areas: 
    "clubtitle space paid action"
    "clubdate space paid action";
    height:140px;
}
.itemDetail{
    display:grid;
    grid-template-columns:300px auto 10px 120px;
    grid-template-rows:1fr;
    grid-template-areas: 
    "clubtitle space paid action";
}
.itemSpace{
    grid-area:space;
    text-align:center;
    display: flex;
    flex-direction: column-reverse;
}
.clubTitle{
    grid-area:clubtitle;
    margin-left:10px;
}
.clubDate{
    margin-left:10px;
}
.titleGrid{
    display:grid;
    grid-template-columns:200px auto 100px 100px;
    grid-template-rows:1fr 1fr 1fr;
    grid-template-areas: 
    "maintitle space paid action"
    "address1 phone paid action"
    "address2 email paid action";
}
.itemAction{
    grid-area:action;
    display:flex;
    flex-direction: column;
    text-align: center;
}

/* itemtitle */
.itemTitleBar{
    display:grid;
    grid-template-columns:200px  auto 140px 110px;
    grid-template-rows:auto;
    grid-template-areas: 
    "title  space inactive add";
    margin-left:10px;
    margin-right:10px;
  
}
.itemTitle{
    grid-area:title;
    
}
.itemBarTitle{
    font-size:x-large;
    /* color:rgb(0,158,192); */
    color:rgb(0,158,192);
    font-weight: bold;
}
.itemBarSubTitle{
    font-size:large;
    color:rgb(0,158,192);
    /* color:rgb(0,158,192); */
    margin-top:30px;
    margin-left:30px;
}
.inactiveCheck{
    grid-area:inactive;
    margin-top:30px;
    color:rgb(0,158,192);
}
.addButton{
    grid-area:add;
    background-color:rgb(238,120,45);
   color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   width: 100px;
   height:40px;
   margin-top:20px;
   margin-right:20px;
}
.duesCheck{
    margin-top:30px;
    margin-left:20px;
}

.button{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}
button:disabled{
    background-color:lightgray;
}
.buttonPerson{
  background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 5px 20px;
   width: 85px;
}


.innerTransparent{

    padding:0px;
    text-align: left;

}

.editLabel{
    width:60px;
    margin:10px;
}
.editField{
    border-width: 1;
    border-color:darkgray;
    border-radius: 5px;
    font-size:inherit;
    width:160px;
    margin:5px;
}




</style>

